import { i18n } from '../../lang'

export const columnList = [
  { type: 'id', custom: { width: 60 } },
  { type: 'store_name', custom: { minWidth: 160 } },
  { type: 'name', custom: { minWidth: 160 } },
  { type: 'username', custom: { minWidth: 120 } },
  { type: 'store_email', custom: { minWidth: 190 } },
  { type: 'website', custom: { width: 80 } },
  { type: 'approved', custom: { width: 82 }, isSwitch: true },
  {
    type: 'status', custom: { width: 82 }, title: i18n.t('table.online'), isSwitch: true,
  },
]

export const websiteList = [
  { key: 'facebook_url', title: i18n.t('table.facebook') },
  { key: 'instagram_url', title: i18n.t('table.instagram') },
  { key: 'website_url', title: i18n.t('table.website') },
]

export const merchantDetailAttributes = [
  { key: 'name' },
  { key: 'store_email' },
  { key: 'username' },
  { key: 'login_email' },
  { key: 'legal_name' },
  { key: 'categories' },
  { key: 'address' },
  { key: 'phone' },
  { key: 'shipment_options' },
  { key: 'pickup_options' },
  { key: 'payment_setting' },
  { key: 'total_products' },
  { key: 'merchant_terms_version' },
  { key: 'merchant_terms_signed_at' },
]
